export class User {
  name: string;
  email: string;
  password: string;

  administrator: boolean = false;
}
